import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db82c51a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=db82c51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db82c51a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db82c51a')) {
      api.createRecord('db82c51a', component.options)
    } else {
      api.reload('db82c51a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db82c51a&scoped=true&", function () {
      api.rerender('db82c51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/medical-analyses/index.vue"
export default component.exports